const QUERY_LIST_ADDITIONS = 'QUERY_LIST_ADDITIONS';
const QUERY_LIST_DEDUCTIONS = 'QUERY_LIST_DEDUCTIONS';
const QUERY_LIST_SALARY_COMPONENTS = 'QUERY_LIST_SALARY_COMPONENTS';
const QUERY_LIST_ADDITIONS_DEDUCTIONS_LOP = 'QUERY_LIST_ADDITIONS_DEDUCTIONS_LOP';
const OVERTIME_FORMULA_CARDS_KEY = 'overtime-formula-cards';
const OVERTIME_LIST_ENTRIES_KEY = 'overtime-list-entries';

const queryKeys = {
  QUERY_LIST_ADDITIONS,
  QUERY_LIST_DEDUCTIONS,
  QUERY_LIST_SALARY_COMPONENTS,
  QUERY_LIST_ADDITIONS_DEDUCTIONS_LOP,
  OVERTIME_FORMULA_CARDS_KEY,
  OVERTIME_LIST_ENTRIES_KEY
};

export default queryKeys;